<section class="composer" aria-label="Share a status update">
  <div class="composer__body">
    <ut-avatar-badges class="composer__avatar" user="me" aria-hidden="true"></ut-avatar-badges>
    <ut-community-status-form class="composer__form" [busy]="posting()" [authorUserType]="authorUserType()" (submitted)="post($event)"></ut-community-status-form>
  </div>
  <p class="composer__footer">Have more to say? <a href="/forums">Browse the forum</a> to join community discussions.</p>
</section>
